export default class CommunityObject {
  constructor(objectType) {
    this.objectType = objectType;
    this.validationErrors = [];
  }
  validate() {
    let errorsToken = [];
    Object.keys(this).forEach(function(key, value) {
      if (!value && (key != "validationErrors" && key != "objectType")) {
        errorsToken.push("Missing or invalid value for the property: ", key);
      }
    });
    this.validationErrors = errorsToken;
    if (this.validationErrors.length > 0) {
      console.warn(
        "corpuls simulation: Validation Errors With Object: " + this.objectType
      );
      console.table(this.validationErrors);
    }
  }
}
